import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { AnnualPlanGraphDialogComponent } from './annual-plan-graph-dialog.component';
import { ExercicesProvider } from '../../../exercices/providers/exercices-provider';
import { HorizontalScrollDirective } from '../../directive/horizontal-scroll';
import BaseGraph from './base-graph';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Organization } from "../../../common/models/organization";
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Week } from "../../../common/models/week";
import { AnnualPlanPhase } from "../../../common/models/annual-plan.phase";
import { AnnualPlanMacroCycle } from "../../../common/models/annual-plan-macro-cycle";
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { MatRipple } from "@angular/material/core";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'app-annual-plan-graph',
  templateUrl: './annual-plan-graph.component.html',
  styleUrls: ['./graph.scss'],
  imports: [
    NgIf,
    NgClass,
    TranslateModule,
    NgStyle,
    MatRipple,
    HorizontalScrollDirective,
    NgForOf,
    AppDatePipe,
    MatTooltip
  ],
  standalone: true
})
export class AnnualPlanGraphComponent extends BaseGraph implements AfterViewInit, DoCheck, OnChanges, OnDestroy {

    @Input() public organization: Organization | null = null;
    @Input() public override annualPlan: AnnualPlan = new AnnualPlan({});
    @Input() public override weeks: Week[] | any = [];
    @Input() public annualPlanPhases: AnnualPlanPhase[] = [];
    @Input() public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
    @Input() public isEditMode: boolean = false;
    @Input() public override clickedWeek: Week | undefined;
    @Input() public override viewMode = 'big';
    @Input() public override showMonths = false;
    @Input() public scrollPosition: number | undefined;

    @Output() public weekSelectedEvent: EventEmitter<Week> = new EventEmitter<Week>();
    @Output() public annualPlanPhaseClickedEvent: EventEmitter<AnnualPlanPhase> = new EventEmitter<AnnualPlanPhase>();
    @Output() public annualPlanMacroCycleClickedEvent: EventEmitter<AnnualPlanMacroCycle> = new EventEmitter<AnnualPlanMacroCycle>();
    @Output() public weeksChange = new EventEmitter<Week[]>();
    @Output() public addMacroCycleEvent = new EventEmitter();
    @Output() public addPhaseEvent = new EventEmitter();
    @Output() public override graphScrollPosition = new EventEmitter();

    public exerciseCategories: ExerciceCategory[] = [];

    @ViewChild('scrollable', {static: false})
    public override graphInnerDiv!: ElementRef;

    @ViewChild(HorizontalScrollDirective, {static: false})
    public override scroll!: HorizontalScrollDirective;

    public currentLang: string;

    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MatDialog,
        protected exerciseProvider: ExercicesProvider,
        private cdr: ChangeDetectorRef,
        private ts: TranslateService,
    ) {
        super();

        this.currentLang = ts.currentLang;
    }

    public ngAfterViewInit() {
      this.loadExercises();
      this.loadGraph(true);
      this.isLoading = false;
      this.cdr.detectChanges();
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.loadGraph(true);
        this.onChanges(changes);
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public loadExercises() {
        this.subscriptions.push(
            this.exerciseProvider.getExerciseCategories(this.organization!).subscribe((categories) => {
                this.exerciseCategories = categories;
            })
        );
    }

    public onWeekClicked(week: any) {
        this.clickedSelector = week.id;
        if (this.isEditMode) {
            this.weekSelectedEvent.emit(week);
            this.weeksChange.emit(this.weeks);

            return;
        }

        const dialogRef = this.dialog.open(AnnualPlanGraphDialogComponent, {
            data: {week}
        });

        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((result) => {
                this.clickedSelector = null;
            })
        );
        this.cdr.detectChanges();
    }

    public onPhaseClicked(annualPlanPhase: AnnualPlanPhase) {
        this.annualPlanPhaseClickedEvent.emit(annualPlanPhase);
    }

    public onMacroCycleClicked(annualPlanMacroCycle: AnnualPlanMacroCycle) {
        this.annualPlanMacroCycleClickedEvent.emit(annualPlanMacroCycle);
    }

    public addMacroCycle(week: any) {
        this.addMacroCycleEvent.emit(week);
    }

    public addPhase(week: any) {
        this.addPhaseEvent.emit(week);
    }

    public hasData() {
        for (const week of this.weeks) {
            if (
              (week.sportPercent && week.sportPercent > 0)
              || (week.physicalPercent && week.physicalPercent > 0)
              || (week.intensityPercent && week.intensityPercent > 0)
              || week.comment != null
            ) {
                return true;
            }
        }

        return false;
    }

    /**
     * Recompute SVG points on detection change
     */
    public ngDoCheck() {
        this.calculateSvgPoints();
    }
}
